import { combineReducers } from 'redux';

import dealer from './dealer';
import filters from './filters';

// TODO - ADD GROUP
export default combineReducers({
  filters,
  dealer,
});
